import {
  estimatedDeliveryDateSelector,
  deliveredDateSelector,
} from '../../../../../data/orders.js'

import LabelItem from './LabelItem.js'
import ShipDate from '../../../Fields/ShipDate.js'
import {useSelector} from '../../../../../store.js'

export default function ShipEstimatedOrDeliveredDate({orderNumber}) {
  const estimatedDeliveryDate = useSelector((state) =>
    estimatedDeliveryDateSelector(state, {
      orderNumber,
    }),
  )
  const deliveredDate = useSelector((state) =>
    deliveredDateSelector(state, {
      orderNumber,
    }),
  )

  if (!estimatedDeliveryDate && !deliveredDate) {
    return null
  }

  return (
    <LabelItem
      label={deliveredDate ? 'Delivered Date' : 'Estimated Delivery Date'}
    >
      <ShipDate date={deliveredDate || estimatedDeliveryDate} />
    </LabelItem>
  )
}
